.audio_player {

    .audio_player_button {
        padding: 0;
    }

    &[data-size='small'] {
        font-size: 12px;

        .audio_player_button {

            :global(.anticon) {
                font-size: 24px !important;
            }
        }
    }

    &[data-size='middle'] {
        font-size: 13px;

        .audio_player_button {

            :global(.anticon) {
                font-size: 27px !important;
            }
        }
    }

    &[data-size='large'] {
        font-size: 15px;

        .audio_player_button {

            :global(.anticon) {
                font-size: 30px !important;
            }
        }
    }
}